import { Component } from "react"

/* Constants */
import { utils, sound, env } from "../constants"

/* UUID */
import { v4 as uuidv4 } from "uuid"

/* Components */
import { Picture, Chip } from "@cuba-go/poker-ui"
import { createEmptyStake } from "../constants/values"

/* Components */
// import Chip from "../components/Chip"

/* Widget Bet */
class Bet extends Component {


    constructor() {
        super()

        this.state = {
            history: [],
        }
    }

    soundBlock = () => {
        sound.play("blocked")
    }

    /* Clear action */
    clear = () => {
        const { setStakes, setList, currentTime, isClosed, total } = this.props

        if (total && (currentTime > 2 || isClosed)) {
            setStakes([
                createEmptyStake(),
                createEmptyStake(),
                createEmptyStake()
            ])

            setList([])
            sound.play()
        } else {
            this.soundBlock()
        }

    }


    cancel = () => {

        const { list, stakes, setList, setStakes, currentTime, isClosed, total } = this.props

        if (total && (parseInt(currentTime) > 2 || isClosed)) {
            if (!Array.isArray(list) || list.length === 0) {
                this.clear()
                return
            }

            const lastAction = list[list.length - 1]

            if (!lastAction.prev) {
                sound.play("blocked")
                return
            }

            const restoredStakes = stakes.map((s, i) => {
                const prev = lastAction.prev.find(p => p.box === i)
                return prev ? { ...prev.stake } : s
            })

            setStakes(restoredStakes)
            setList(list.slice(0, -1))

        } else {
            sound.play("blocked")
        }

    }

    /* Double action */
    double = () => {

        const {
            stakes,
            setStakes,
            boxPlayers,
            playerId,
            total,
            balance,
            list,
            max,
            setList,
            toggleBalanceError,
            toggleMaxBetError
        } = this.props

        const safeList = Array.isArray(list) ? list : []

        /* боксы игрока */
        const playerBoxes = boxPlayers
            .map((p, i) => (p?.playerId === playerId ? i : null))
            .filter(i => i !== null)

        /* только где есть ante */
        const betBoxes = playerBoxes.filter(i => stakes[i]?.ante > 0)

        if (!betBoxes.length || !total) {
            this.soundBlock()
            return
        }

        /* ===== проверка баланса ===== */
        let requiredBalance = 0

        betBoxes.forEach(i => {
            requiredBalance += (stakes[i].ante || 0) + (stakes[i].trips || 0)
        })

        if (balance < requiredBalance) {
            toggleBalanceError()
            return
        }

        /* ===== проверка max ===== */
        const exceedMax = betBoxes.some(i => {
            const nextAnte = (stakes[i].ante || 0) * 2
            const nextTrips = (stakes[i].trips || 0) * 2

            return max && (nextAnte > parseInt(max) || nextTrips > parseInt(max))

        })

        if (exceedMax) {
            toggleMaxBetError()
            return
        }

        /* сохраняем предыдущее состояние */
        const prev = betBoxes.map(i => ({
            box: i,
            stake: { ...stakes[i] }
        }))

        /* применяем double */
        const nextStakes = stakes.map((s, i) =>
            betBoxes.includes(i)
                ? {
                    ...s,
                    ante: (s.ante || 0) * 2,
                    trips: (s.trips || 0) * 2
                }
                : s
        )

        setStakes(nextStakes)
        setList([...safeList, { type: "double", prev }])
    }

    /* Refresh action */
    refresh = () => {

        const {
            last,
            stakes,
            setStakes,
            setList,
            list,
            total,
            balance,
            toggleBalanceError,
            boxPlayers,
            playerId
        } = this.props

        if (!Array.isArray(last) || total) {
            this.soundBlock()
            return
        }

        const playerBoxes = boxPlayers
            .map((p, i) => (p?.playerId === playerId ? i : null))
            .filter(i => i !== null)

        if (!playerBoxes.length) {
            this.soundBlock()
            return
        }

        let requiredBalance = 0

        playerBoxes.forEach(i => {
            const s = last[i]
            if (!s) {
                this.soundBlock()
                return
            }

            requiredBalance +=
                (s.ante || 0) * 2 +
                (s.trips || 0)
        })

        if (requiredBalance === 0) {
            this.soundBlock()
            return
        }

        if (balance < requiredBalance) {
            toggleBalanceError()
            return
        }

        const prev = playerBoxes.map(i => ({
            box: i,
            stake: { ...stakes[i] }
        }))

        const nextStakes = stakes.map((s, i) =>
            playerBoxes.includes(i) && last[i]
                ? { ...last[i] }
                : s
        )

        setStakes(nextStakes)
        setList([...(Array.isArray(list) ? list : []), { type: "refresh", prev }])
    }

    /* SET DEFAULT CHIP */
    setActiveChip = item => {

        const { active, setActiveChip } = this.props

        if (item.key !== active) {
            setActiveChip(item.key)
            sound.play("selectchip")
        } {
            this.soundBlock()
        }

    }


    /* Draw Chips */
    _chips = () => {

        /* Fields */
        const { active } = this.props
        const { chips } = this.props

        const list = utils.getChips(chips)

        return (
            <div className="chips">
                {list.map((item, index) =>
                    <div onClick={() => this.setActiveChip(item)} key={`${index}`} className={item.key === active ? `chip active-chip` : `chip`}>
                        <Chip value={item.value} chips={chips} size={60} />
                    </div>
                )}
            </div>

        )
    }


    render = () => {

        /* Fields */
        const { last, total } = this.props

        let isLastPresent = false
        if (last && Array.isArray(last)) {
            last.forEach(item => {
                if (item && item.ante) {
                    isLastPresent = true
                }
            })
        }

        return (
            <div className="bet">

                <div className="bet-panel">

                    <div className="bet-buttons">

                        {/* Clear Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.clear()}>
                            <Picture src={`${env.mediapoint}/images/bet/delete.png`} alt="Delete" />
                            <span>Очистить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.cancel()}>
                            <Picture src={`${env.mediapoint}/images/bet/cancel.png`} alt="Cancel" />
                            <span>Отменить</span>
                        </div>

                    </div>

                    {/* Chips */}
                    {this._chips()}

                    <div className="bet-buttons">

                        {/* Double Up Button */}
                        <div className={`bet-button ${!total && "disabled"}`} onClick={() => this.double()}>
                            <div className="bet-title">2x</div>
                            <span>Удвоить</span>
                        </div>

                        {/* Cancel Button */}
                        <div className={`bet-button ${(!isLastPresent || total) && "disabled"}`} onClick={() => this.refresh()}>
                            <Picture src={`${env.mediapoint}/images/bet/refresh.png`} alt="Refresh" />
                            <span>Повторить</span>
                        </div>

                    </div>

                </div>

            </div>
        )
    }

}

export default Bet